module.exports = __webpack_public_path__ + "54dc2bcc68e11376832c9dcefe6e9e09.png";